
export interface DataConnector {
  id: string;
  name: string;
  logoUrl: string;
  description: string;
  status: 'available' | 'coming_soon';
  category: string;
  features: string[];
  type: string;
  service: string;
  icon_url?: string;
  icon?: string;
  icons?: any;
  isAvailable?: boolean; // Add this to match the index.ts interface
}

export interface LinkedConnector {
  id: string;
  name: string;
  logoUrl: string;
  status: 'connected' | 'pending' | 'error';
  connectorId: string;
  connectionId: string;
  created_at: string;
  service?: string;
  type?: string;
  metadata?: any;
  file_name?: string;
  import_type?: string;
  ecommerce_subtype?: string;
}

export interface StandardizedConnection {
  id: string;
  name: string;
  status: 'connected' | 'pending' | 'error';
  logoUrl: string;
  service: string;
  connectorId: string;
  description: string;
  connectionId: string;
  type: string;
  created_at: string;
  /** Amazon Seller Central vs Vendor Central. Absent on non-Amazon connections. */
  amazon_account_type?: 'seller' | 'vendor';
  metadata?: any;
  file_name?: string;
  import_type?: string;
  ecommerce_subtype?: string;
  csvImports?: Array<{
    id?: string;
    date: string;
    fileName: string;
    snapshot_connection_id?: string;
    /** YYYY-MM-DD inventory snapshot date (import-inventory-csv-v3). */
    snapshot_date?: string;
    /** Ledger / variance source key, e.g. shopify_csv_import */
    inventory_source?: string;
    csv_import_job_id?: string;
  }>;
  // Fivetran reconnection properties
  needs_reconnect?: boolean;
  reconnect_url?: string;
  setup_state?: string;
}

export interface DataConnectionResponse {
  success: boolean;
  data?: {
    url: string;
    connectorId: string;
    connectionId: string;
  };
  error?: string;
}

export interface Connection {
  id: string;
  name: string;
  type: string;
  status: string;
  created_at: string;
  connectionId?: string;
  amazon_account_type?: 'seller' | 'vendor';
  metadata?: any;
  import_type?: string;
  ecommerce_subtype?: string;
  csvImports?: Array<{
    id?: string;
    date: string;
    fileName: string;
    snapshot_connection_id?: string;
    /** YYYY-MM-DD inventory snapshot date (import-inventory-csv-v3). */
    snapshot_date?: string;
    /** Ledger / variance source key, e.g. shopify_csv_import */
    inventory_source?: string;
    csv_import_job_id?: string;
  }>;
  file_name?: string;
}

export interface FileImport {
  id: string;
  file_name: string;
  file_type: string;
  file_size: number;
  storage_path?: string;
  connection_id: string;
  created_at: string;
  content?: any;
}

// Conversion functions

export const convertToConnections = (standardizedConnections: StandardizedConnection[]): Connection[] => {
  return standardizedConnections.map(conn => ({
    id: conn.id,
    name: conn.name,
    type: conn.type,
    status: conn.status,
    created_at: conn.created_at,
    connectionId: conn.connectionId,
    amazon_account_type: conn.amazon_account_type,
    metadata: conn.metadata,
    import_type: conn.import_type,
    ecommerce_subtype: conn.ecommerce_subtype,
    file_name: conn.file_name,
    csvImports: conn.csvImports
  }));
};

export const convertFileImportsToStandardizedConnections = (fileImports: FileImport[]): StandardizedConnection[] => {
  return fileImports.map(file => ({
    id: file.id,
    name: `File: ${file.file_name}`,
    status: 'connected' as const,
    logoUrl: "https://via.placeholder.com/40?text=FILE",
    service: 'file',
    connectorId: file.connection_id,
    description: `${file.file_type} file: ${file.file_name}`,
    connectionId: file.connection_id,
    type: file.file_type,
    created_at: file.created_at,
    metadata: {
      file_name: file.file_name,
      file_size: file.file_size,
      file_type: file.file_type,
      storage_path: file.storage_path
    },
    file_name: file.file_name
  }));
};
